export default __webpack_public_path__ + "static/media/backward-circle-arrow.3ac22c29.svg";